import { useUpdateDemoFromRecordingMutation } from '@carboncopyco/data';
import { InfoOutlineIcon } from '@carboncopyco/icons';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import {
  Button,
  ColorHex,
  Loading,
  MessageBox,
  TextBase,
  notify,
} from '@carboncopyco/ui';
import { useSessionStorageState } from 'ahooks';
import { usePermissionsContext } from '../../utils';
import { useDemoPageProps } from './DemoPageContext';
import { useShouldUpdateDemoFromRecording } from './useShouldUpdateDemoFromRecording';

export const UpdateDemoIndication = () => {
  const { demoId, organizationId, workspaceId } = useDemoPageProps();
  const { getPermissions } = usePermissionsContext();
  const updatesAvailable = useShouldUpdateDemoFromRecording(
    demoId,
    workspaceId,
    organizationId
  );
  const [updateDemoFromRecording, { isLoading: isLoadingUpdateFromRecording }] =
    useUpdateDemoFromRecordingMutation();
  const [hideBanner, setHideBanner] = useSessionStorageState<
    boolean | undefined
  >('hideUpdateDemoBanner', { defaultValue: updatesAvailable });

  const updateDemoPermission = getPermissions(
    PermissionKey.demo,
    PermissionAction.updateDemoById
  );

  return updatesAvailable && !hideBanner && updateDemoPermission ? (
    <MessageBox
      info
      close
      handleClose={() => setHideBanner(true)}
      roundedCorners={false}
      label={
        <div className="flex justify-center w-full gap-1.5 ">
          <InfoOutlineIcon
            color={ColorHex.primary500}
            size={20}
          />
          <TextBase
            label="This demo’s clone was updated. Make sure to set the latest clone version."
            color="text-ds-primary-500"
          />
          <div className="[&>button]:p-0 pl-1 flex items-center">
            <Button
              link
              blue
              label="Update demo"
              textColor="text-ds-primary-500"
              noPadding
              disabled={isLoadingUpdateFromRecording}
              onClick={() =>
                updateDemoFromRecording({
                  organizationId,
                  id: demoId,
                }).catch(() => notify.error('Error updating demo'))
              }
            />
            {isLoadingUpdateFromRecording && (
              <div className="pl-3">
                <Loading
                  color="text-ds-primary-500"
                  size={16}
                />
              </div>
            )}
          </div>
        </div>
      }
    />
  ) : null;
};
